import React, { useState, useEffect, useRef } from "react";
import "../CSS/Questions.css";
import { useLocation } from "react-router-dom";
import { CallService, modalAlert, isdigit, handleKeyDown, toPersianUniCode } from "../JS/scripts";
import Loading from "./Loading";
import { useIsLoading, useSetIsLoading } from "../JS/UseContext/LoaadingContext.js";
import { TextField, Textarea } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import arrow from "../Resources/Images/arrow.svg";
import Rating from "@mui/material/Rating";
//import Alborz from "../Resources/Images/Alborz.png";

function Questions() {
    const { state } = useLocation();
    const [survey, setSurvey] = useState("");
    const [questions, setQuestions] = useState("");
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [dataArray, setDataArray] = useState([]);
    const [answer, setAnswer] = useState({});
    const [selectOptions, setSelectOptions] = useState([]);
    const [chooseOptions, setChooseOptions] = useState("");
    const [autoNext, setAutoNext] = useState(false);
    const [checkMark, setCheckMark] = useState(false);
    const [onlyOnce, setOnlyOnce] = useState(false);
    const [progressPercentage, setProgressPercentage] = useState("");
    // const [star, setStar] = useState(null);
    const setIsLoading = useSetIsLoading();
    const IsLoading = useIsLoading();
    var x = "پرسش نامه ای یافت نشد.";

    const inputRefs = {
        dvQuestion: useRef(null),
        saveQuestionsTxt: useRef(null),
        nextBtn: useRef(null),
        submitBtn: useRef(),
        currentQuestionRef: useRef(),
        currentElRef: useRef(),
    };

    const handleOnInput = event => {
        event.target.value = event.target.value.toPersianUniCode();
    };

    useEffect(() => {
        setOnlyOnce(true);
        setTimeout(() => {
            setOnlyOnce(false);
        }, 100);
    }, []);
    useEffect(() => {
        if (state && state.surveyId) {
            CallService(`Surveys/${state.surveyId}`, {}, "GET", setIsLoading, true)
                .then(survey => {
                    localStorage.setItem('insuranceCompanyId', survey.insuranceCompanyId);
                    setSurvey(survey);
                })
                .catch(error => {
                    modalAlert(error.message || error || "خطای غیر منتظره رخ داده لطفا با پشتیبانی نرم افزار تماس بگیرید.");
                });

            CallService(`Clients/${state.surveyId}/questions?referenceValue=${state.reference}`, {}, "GET", setIsLoading, true)
                .then(questions => {
                    setQuestions(questions.sort((a, b) => a.orderNo - b.orderNo));
                })
                .catch(error => {
                    modalAlert(error.message || error || "خطای غیر منتظره رخ داده لطفا با پشتیبانی نرم افزار تماس بگیرید.");
                });
        }
    }, [state]);

    const handleOnRadioChange = (event, chooseOptions) => {
        const op = chooseOptions.find(option => option.Value == +event.target.value);
        setAnswer({
            Value: event.target.value,
            Weight: op && op.Weight ? op.Weight : null,
        });
        setAutoNext(true);
    };
    useEffect(() => {
        if (autoNext) {
            if (questions.length - 1 === currentQuestionIndex) {
                handleRegister();
                setAutoNext(false);
            } else {
                handleNextQuestion();
                setAutoNext(false);
            }
        }
    }, [autoNext]);
    function saveQuestionAnswers(updatedArray) {
        if (survey.onlyOnce && localStorage.getItem(`s-${state.surveyId}-${state.reference}`) == `s-${state.surveyId}-${state.reference}`) {
        } else {
            var data = {
                surveyId: survey.surveyId,
                referenceValue: state.reference || null,
                answers: updatedArray,
                secondReferenceId: parseInt(state.secondReferenceId)
            };
            CallService(`QuestionAnswers`, data, "POST", setIsLoading, true)
                .then(res => {
                    localStorage.setItem(`s-${state.surveyId}-${state.reference}`, `s-${state.surveyId}-${state.reference}`);
                    setCheckMark(true);
                })
                .catch(error => {
                    modalAlert(error.message || error || "خطای غیر منتظره رخ داده لطفا با پشتیبانی نرم افزار تماس بگیرید.");
                });
        }
    }

    useEffect(() => { }, [currentQuestionIndex]);

    useEffect(() => {
        if (questions[currentQuestionIndex]) {
            if (questions[currentQuestionIndex].type == "Select") {
                var options = JSON.parse(questions[currentQuestionIndex].options);

                var newOptions = options.map(element => {
                    element.Value = element.Value.toPersianUniCode();
                    return element;
                });

                setSelectOptions(newOptions);
            }
            if (questions[currentQuestionIndex].type == "Choose") {
                setChooseOptions(JSON.parse(questions[currentQuestionIndex].options));
            }
            if (inputRefs.currentElRef.current != null) {
                if (inputRefs.currentElRef.current.querySelector("input")) {
                    inputRefs.currentElRef.current.querySelector("input").focus();
                } else if (inputRefs.currentElRef.current.querySelector("textarea")) {
                    inputRefs.currentElRef.current.querySelector("textarea").focus();
                }
            }
        }
    }, [questions[currentQuestionIndex]]);

    useEffect(() => {
        if (questions[currentQuestionIndex]) {
            const answeredQuestion = dataArray.find(item => item.questionId === questions[currentQuestionIndex].questionId);
            setAnswer({
                Value: answeredQuestion ? answeredQuestion.value : null,
                Weight: answeredQuestion ? answeredQuestion.weight : null,
            });
            if (answeredQuestion && questions[currentQuestionIndex].type == "Select") {
                setAnswer({
                    Value: answeredQuestion.value,
                    Weight: answeredQuestion.weight,
                });
            }
        }
    }, [currentQuestionIndex, questions, dataArray]);

    const handleNextQuestion = () => {
        const updatedArray = [...dataArray];
        const currentQuestion = questions[currentQuestionIndex];
        const targetQuestionId = currentQuestion.questionId;
        const itemIndex = updatedArray.findIndex(item => item.questionId === targetQuestionId);

        if (itemIndex !== -1) {
            updatedArray[itemIndex].value = answer.Value ? answer.Value : answer;
        } else {
            updatedArray.push({
                questionId: targetQuestionId,
                value: answer.Value,
                weight: answer.Weight,
            });
        }
        window.history.pushState(null, "", "");
        setDataArray(updatedArray);

        setAnswer({ Value: null, Weight: null });

        inputRefs.dvQuestion.current.classList.remove("show");
        if (currentQuestionIndex < questions.length - 1) {
            inputRefs.dvQuestion.current.classList.add("fade");
            setTimeout(() => {
                setCurrentQuestionIndex(currentQuestionIndex + 1);
                inputRefs.dvQuestion.current.classList.add("show");
            }, 500);
        }
    };
    const handleRegister = async () => {
        const updatedArray = [...dataArray];
        const currentQuestion = questions[currentQuestionIndex];
        const targetQuestionId = currentQuestion.questionId;
        const itemIndex = updatedArray.findIndex(item => item.questionId === targetQuestionId);

        if (itemIndex !== -1) {
            updatedArray[itemIndex].value = answer.value;
        } else {
            updatedArray.push({
                questionId: targetQuestionId,
                value: answer.Value,
                weight: answer.Weight,
            });
        }
        await setDataArray(updatedArray);
        saveQuestionAnswers(updatedArray);
        // await setDataArray([
        //     ...dataArray,
        //     {
        //         questionId:
        //             questions[currentQuestionIndex].questionId,
        //         value: answer,
        //     },
        // ]);
    };

    function onAnswerKeyDown(event) {
        if (
            (questions[currentQuestionIndex].required && !answer.Value) ||
            (answer &&
                (questions[currentQuestionIndex].min || questions[currentQuestionIndex].max) &&
                (answer.Value < questions[currentQuestionIndex].min || answer.Value > questions[currentQuestionIndex].max))
        ) {
        } else {
            const isLastQuestion = questions.length - 1 == currentQuestionIndex;

            handleKeyDown(event, isLastQuestion ? inputRefs.submitBtn : inputRefs.nextBtn, "btn");
        }
    }

    useEffect(() => {
        const handleBackButton = event => {
            if (currentQuestionIndex) {
                event.preventDefault();
                setCurrentQuestionIndex(currentQuestionIndex - 1);
            }
        };

        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, [currentQuestionIndex]);

    useEffect(() => {
        const progressPercentageCo = (currentQuestionIndex / questions.length) * 100;
        setProgressPercentage(progressPercentageCo);
    }, [currentQuestionIndex]);

    const progressBarStyle = {
        width: `${progressPercentage && progressPercentage != NaN ? progressPercentage : 0}%`,
        backgroundColor: "#055a1ee0",
        height: "15px",
        transition: "width 0.5s ease-in-out",
    };
    return (
        <div id="questions">
            {IsLoading && <Loading />}
            {
                localStorage.getItem("insuranceCompanyId") ?
                    (<div className="insuranceCompany-logo">
                        <img src={process.env.PUBLIC_URL + '/Custom/' + localStorage.getItem("insuranceCompanyId") + '.png'} alt="insuranceCompany" />
                    </div>) :
                    ("")
            }

            {!checkMark && questions && questions.length > 0 && questions.sort((a, b) => a.orderNo - b.orderNo) && (
                <div id="dvQuestion" className={`flexCulomn`} style={{ justifyContent: "flex-start" }} ref={inputRefs.dvQuestion}>
                    <div id="dvSurvey" className="flexCulomn">
                        <span>نظر سنجی:</span>
                        <h4>{survey.title ? survey.title : x}</h4>
                    </div>
                    <div className="questionDetailsBox" ref={inputRefs.currentQuestionRef}>
                        <div className="question-box">
                            <div>
                                <div
                                    style={{
                                        border: "1px solid #ccc",
                                        borderRadius: "20px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <div style={progressBarStyle}></div>
                                </div>
                                <p id="currentQuestionNum">{"سوال " + ` ${currentQuestionIndex + 1} ` + "از " + questions.length}</p>
                            </div>
                            <div className="questionDetailsBox-title">
                                {`${currentQuestionIndex + 1 + "-"}`} {questions[currentQuestionIndex].text}
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    height: "fit-content",
                                    justifyContent: "center",
                                }}
                                className="flexCulomn questionDetailsBox-body"
                            >
                                {questions[currentQuestionIndex].type === "Text" && (
                                    <TextField
                                        variant="outlined"
                                        className="TextField textareaPadding label-rtl-dir font rtl"
                                        multiline
                                        rows={2}
                                        value={answer.Value || ""}
                                        onChange={event => {
                                            // !/^\d+$/.test(event.target.value.trim()) &&
                                            var x = questions[currentQuestionIndex].charCount;
                                            var regex = new RegExp(`^.{0,${x}}$`);
                                            if (event.target.value.trim() !== "") {
                                                if (!regex.test(event.target.value.trim())) {
                                                    setAnswer({
                                                        Value: answer.Value,
                                                        Weight: null,
                                                    });
                                                } else {
                                                    setAnswer({
                                                        Value: event.target.value,
                                                        Weight: null,
                                                    });

                                                }
                                            } else {
                                                setAnswer({
                                                    Value: null,
                                                    Weight: null,
                                                });
                                            }
                                        }}
                                        inputProps={{
                                            maxLength: questions[currentQuestionIndex].charCount
                                        }}
                                        ref={inputRefs.currentElRef}
                                        onKeyDown={onAnswerKeyDown}
                                    />
                                )}
                                {questions[currentQuestionIndex].type === "Num" && (
                                    <div style={{ color: "gray" }}>
                                        حداقل : {questions[currentQuestionIndex].min}
                                        <br></br>
                                        حداکثر : {questions[currentQuestionIndex].max}
                                        <TextField
                                            variant="outlined"
                                            className="TextField textareaPadding label-rtl-dir ltr"
                                            value={answer.Value || ""}
                                            onChange={e => {
                                                if (isdigit(e.target.value)) {
                                                    setAnswer({
                                                        Value: e.target.value,
                                                        Weight: null,
                                                    });
                                                } else {
                                                    setAnswer({
                                                        Value: null,
                                                        Weight: null,
                                                    });
                                                }
                                            }}
                                            ref={inputRefs.currentElRef}
                                            type="tel"
                                            onKeyDown={onAnswerKeyDown}
                                        />
                                    </div>
                                )}
                                {questions[currentQuestionIndex].type === "Select" && (
                                    <Autocomplete
                                        className="label-rtl-dir btn-disply autocomplete"
                                        options={selectOptions}
                                        getOptionLabel={option => option.value || option.Value || ""}
                                        noOptionsText={"موردی یافت نشد."}
                                        // open={false}
                                        onChange={(event, value) => {
                                            if (value) {
                                                setAnswer(value);
                                                setAutoNext(true);
                                            } else {
                                                setAnswer({
                                                    value: null,
                                                    weight: null,
                                                });
                                            }
                                        }}
                                        value={selectOptions.find(option => option.Value === answer.Value) || null}
                                        renderInput={params => <TextField {...params} variant="outlined" className={"Autocomplete-TextField label-rtl-dir"} onInput={handleOnInput} ref={inputRefs.currentElRef} />}
                                        classes={{
                                            option: "my-custom-option-class",
                                        }}
                                        renderOption={function (props, options) {
                                            return (
                                                <li {...props} key={options.Value} className={"font"} style={{ padding: "10px" }}>
                                                    {options.Value}
                                                </li>
                                            );
                                        }}
                                    />
                                )}
                                {questions[currentQuestionIndex].type === "Choose" && (
                                    <div className="flexCulomn dvRadioGroup">
                                        <FormControl>
                                            {chooseOptions && (
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={answer.Value}
                                                    onChange={event => {
                                                        handleOnRadioChange(event, chooseOptions);
                                                    }}
                                                    className="flexCulomn"
                                                >
                                                    {chooseOptions.map((option, index) => (
                                                        <FormControlLabel value={option.Value} control={<Radio />} label={option.Value} key={index} />
                                                    ))}
                                                </RadioGroup>
                                            )}
                                        </FormControl>
                                    </div>
                                )}

                                {questions[currentQuestionIndex].type === "Score" && (
                                    <div className="flexCulomn" style={{ direction: "ltr" }}>
                                        <Rating
                                            name="size-large"
                                            size="large"
                                            value={+answer.Value}
                                            max={JSON.parse(questions[currentQuestionIndex].options).length}
                                            onChange={async e => {
                                                // setStar(e.currentTarget.value);
                                                var x = await JSON.parse(questions[currentQuestionIndex].options).find(el => el.Value == e.currentTarget.value);

                                                setAnswer(x);
                                                setAutoNext(true);
                                            }}
                                        />
                                    </div>
                                )}

                                <p style={{ color: "gray", margin: "15px" }}>{questions[currentQuestionIndex].hint}</p>
                            </div>
                        </div>
                    </div>

                    <div style={{ height: "20%", width: "100%" }}>
                        <div
                            className="flexRow"
                            style={{
                                width: "100%",
                                justifyContent: "space-around",
                                marginBottom: "5px",
                            }}
                        >
                            <button
                                className={`backBtn ${currentQuestionIndex == 0 ? "hide" : ""}`}
                                onClick={() => {
                                    inputRefs.dvQuestion.current.classList.remove("show");
                                    if (currentQuestionIndex != 0) {
                                        inputRefs.dvQuestion.current.classList.add("fade");
                                        setTimeout(() => {
                                            setCurrentQuestionIndex(currentQuestionIndex - 1);
                                            inputRefs.dvQuestion.current.classList.add("show");
                                        }, 500);
                                    }
                                }}
                            >
                                قبلی
                            </button>
                            <button
                                variant="contained"
                                className={`button ${questions.length - 1 == currentQuestionIndex ? "hide" : ""} ${(questions[currentQuestionIndex].required && !answer.Value) ||
                                    (answer &&
                                        (questions[currentQuestionIndex].min || questions[currentQuestionIndex].max) &&
                                        (answer.Value < questions[currentQuestionIndex].min || answer.Value > questions[currentQuestionIndex].max))
                                    ? "disable"
                                    : ""
                                    }`}
                                onClick={handleNextQuestion}
                                ref={inputRefs.nextBtn}
                            >
                                بعدی
                            </button>
                            <button
                                className={`button ${questions.length - 1 !== currentQuestionIndex ? "hide" : ""} ${(questions[currentQuestionIndex].required && !answer.Value) ||
                                    (answer &&
                                        (questions[currentQuestionIndex].min || questions[currentQuestionIndex].max) &&
                                        (answer.Value < questions[currentQuestionIndex].min || answer.Value > questions[currentQuestionIndex].max))
                                    ? "disable"
                                    : ""
                                    }`}
                                onClick={handleRegister}
                                ref={inputRefs.submitBtn}
                            >
                                ثبت
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {!questions ||
                (questions.length == 0 && (
                    <div
                        className="center"
                        style={{
                            width: "100%",
                            marginTop: "30px",
                            textAlign: "center",
                        }}
                    >
                        امکان پاسخ به این پرسش نامه وجود ندارد.
                    </div>
                ))}
            {survey.onlyOnce && localStorage.getItem(`s-${state.surveyId}-${state.reference}`) == `s-${state.surveyId}-${state.reference}` && onlyOnce && (
                <div
                    className="center"
                    style={{
                        width: "100%",
                        marginTop: "30px",
                        textAlign: "center",
                    }}
                >
                    شما قبلا به این پرسش نامه پاسخ داده اید.
                </div>
            )}

            {checkMark && (
                <div className="wrapper">
                    {" "}
                    <svg className="animated-check" viewBox="0 0 24 24" ref={inputRefs.saveQuestionsTxt}>
                        <path d="M4.1 12.7L9 17.6 20.3 6.3" fill="none" />{" "}
                    </svg>
                    <p style={{ textAlign: "center", direction: "rtl" }}>
                        ثبت با موفقیت انجام شد.
                        <br />
                        با تشکر از همکاری شما
                    </p>
                </div>
            )}
        </div>
    );
}
export default Questions;
